export enum CompensationReason {
  RegularPerformanceEvaluation = 'Regular performance evaluation',
  AttritionPrevention = 'Attrition prevention',
  CounterOffer = 'Counter-offer',
  SeniorityChange = 'Seniority change',
  RoleChange = 'Role change',
  LocationChange = 'Location change',
  MarketConditionsChange = 'Market conditions change',
  HiringOfferTerms = 'Hiring offer terms',
  NewHomeRateAdjustment = 'NewHome rate adjustment',
  AdminFix = 'Admin fix',
}

export const LEGACY_TITLE_PROMOTION = 'Title promotion';
